/**
 * Created by bladron on 07/04/16.
 */
import Reflux from 'reflux';

export default {
    getUser: Reflux.createAction({asyncResult: true})
};



// WEBPACK FOOTER //
// ./js/mywort/commons/actions/UserActions.js